import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ConfigurableLinkListModule } from '../../../common/component/configurable_link_list/configurable_link_list.module';
import { ModalModule } from '../../../common/component/modal/modal.module';
import { ConfigurationKeywordComponent } from './configuration-keyword.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ModalModule,
    ConfigurableLinkListModule
  ],
  declarations: [ConfigurationKeywordComponent],
  exports: [ConfigurationKeywordComponent]
})
export class ConfigurationKeywordModule { }
